import React, { useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { theme } from "../../Assets/Theme/theme";
import TextInput from "../../Components/Common/TextInput";
import Dropdown from "../Common/Dropdown";

const PriceCategory = ({ prices = [], onPricesChange, value, onChange, options }) => {
  const [priceAgeFields, setPriceAgeFields] = useState(() => {
    if (prices.length > 0) {
      console.log(prices?.ageName, "PRICE FROM STATE");
      
      return prices.map((price, index) => ({
        id: index, 
        price: price.price || "",
        salePrice: price.salePrice || "",
        age: price.age || "", 
        ageName: price.ageName || "", 
    }));
    
    }
    return [{ id: Date.now(), price: "", age: "", salePrice: "", ageName: "" }];
  });

  const selectedAges = priceAgeFields.map((field) => field.age).filter(Boolean);

  const handleAddPriceAge = () => {
    const availableOptions = options
      .map(option => ({
        value: option._id || option.value,
        label: option.name || option.label,
      }))
      .filter(option => !selectedAges.includes(option.value));
  
    if (availableOptions.length === 0) return;
  
    const newField = {
      id: Date.now(),
      price: "",
      age: "",
      salePrice: "",
    };
  
    const updatedFields = [...priceAgeFields, newField];
    setPriceAgeFields(updatedFields);
    onPricesChange(updatedFields);
  };
  

  const handleRemovePriceAge = (index) => {
    const updatedFields = priceAgeFields.filter((_, i) => i !== index);
    setPriceAgeFields(updatedFields);
    onPricesChange(updatedFields);
  };
  


  const handleChange = (index, field, value) => {
    setPriceAgeFields(prevFields =>
      prevFields.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      )
    );

    onPricesChange(
      priceAgeFields.map((item, i) => ({
        price: i === index ? (field === "price" ? value : item.price) : item.price,
        salePrice: i === index ? (field === "salePrice" ? value : item.salePrice) : item.salePrice,
        age: i === index ? (field === "age" ? value : item.age) : item.age,
      }))
    );
  };

  const handleAgeChange = (e, index) => {
    const selectedOption = options.find(option => option.value === e.target.value);
    if (selectedOption) {
      handleChange(index, "age", selectedOption.value);
    }
  };

  const formattedOptions = (index) => {
    const currentSelectedAge = priceAgeFields[index].age;

    return options
      .map(option => ({
        value: option._id || option.value,
        label: option.name || option.label
      }))
      .filter(option => option.value === currentSelectedAge || !selectedAges.includes(option.value));
  };


  return (
    <Box>
      {priceAgeFields.map((field, index) => (
        <Box
          key={field.id}
          display="flex"
          flexDirection="column"
          gap={2}
          marginBottom={2}
        >
          <Box display="flex" alignItems="flex-end" gap={2}>
            {/* Price Field */}
            <Box sx={{ width: "30%" }}>
              <Typography variant="body1" sx={{ fontWeight: 700, fontSize: "16px" }}>
                Price
              </Typography>
              <TextInput
                bgColor={theme.colors.inpGray}
                placeholder="Add Price"
                value={field.price}
                onChange={(e) =>
                  handleChange(index, "price", parseFloat(e.target.value) || "")
                }
              />
            </Box>

            {/* Sales Price */}
            <Box sx={{ width: "30%" }}>
              <Typography variant="body1" sx={{ fontWeight: 700, fontSize: "16px" }}>
                Sales Price
              </Typography>
              <TextInput
                type="number"
                bgColor={theme.colors.inpGray}
                placeholder="Add Sales Price"
                value={field.salePrice}
                onChange={(e) =>
                  handleChange(
                    index,
                    "salePrice",
                    parseFloat(e.target.value) || ""
                  )
                }
              />
            </Box>

            {/* Age Selection */}
            <Box sx={{ width: "30%" }}>
              <Typography variant="body1" sx={{ fontWeight: 700, mb: 0.3, fontSize: "16px" }}>
                Age
              </Typography>
              <Dropdown
                label=""
                placeholder="Select an option"
                value={field.age}
                onChange={(e) => handleAgeChange(e, index)}
                options={formattedOptions(index)}
                marginBottom="16px"
                inputHeight="24px"
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                marginBottom: "25px",
              }}
            >
              {/* Add Button */}
              {options.length > selectedAges.length && (
                <IconButton onClick={handleAddPriceAge}>
                  <Box
                    sx={{
                      width: "24px",
                      height: "24px",
                      backgroundColor: theme.colors.orange,
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <AddIcon sx={{ color: "#fff" }} />
                  </Box>
                </IconButton>
              )}


              {priceAgeFields.length > 1 && (
                <IconButton onClick={() => handleRemovePriceAge(index)}>
                <Box
                  sx={{
                    width: "24px",
                    height: "24px",
                    backgroundColor: theme.colors.orange,
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <RemoveIcon sx={{ color: "#fff" }} />
                </Box>
              </IconButton>
              
              )}
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};


const generateTimeSlots = () => {
  const intervals = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const time = `${hour.toString().padStart(2, "0")}:${minute
        .toString()
        .padStart(2, "0")}`;
      intervals.push({ label: time, value: time });
    }
  }
  return intervals;
};

const TimeSlot = ({
  id,
  timeSlot,
  prices,
  onTimeSlotChange,
  onPricesChange,
  onAddTimeSlot,
  onRemoveTimeSlot,
  showRemove,
  selectedTimeSlots,
  value,
  onChange,
  options,
  isTimeSlotAvailable
}) => {
  return (
    <Box sx={{ marginTop: "20px" }}>
      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          {isTimeSlotAvailable === false && <Typography
            variant="body1"
            sx={{ fontWeight: 700, color: theme.colors.text, fontSize: "20px" }}
          >
            Time Slot
          </Typography>}
          <Box display="flex" gap={1} sx={{ marginBottom: "10px" }}>
            {isTimeSlotAvailable === false && <IconButton onClick={onAddTimeSlot}>
              <Box
                sx={{
                  width: "24px",
                  height: "24px",
                  backgroundColor: theme.colors.orange,
                  borderRadius: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <AddIcon sx={{ color: "#fff" }} />
              </Box>
            </IconButton>}

            {showRemove && (
              <IconButton onClick={() => onRemoveTimeSlot(id)}>
                <Box
                  sx={{
                    width: "24px",
                    height: "24px",
                    backgroundColor: theme.colors.orange,
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <RemoveIcon sx={{ color: "#fff" }} />
                </Box>
              </IconButton>
            )}
          </Box>
        </Box>

        {isTimeSlotAvailable === false && (
          <Dropdown
            label=""
            placeholder="Select Time"
            value={timeSlot}
            onChange={(e) => onTimeSlotChange(id, "timeSlot", e.target.value)}
            options={generateTimeSlots().filter(
              (slot) => !selectedTimeSlots.includes(slot.value) || slot.value === timeSlot
            )}
            height="250px"
          />
        )}

      </Box>
      <PriceCategory
        prices={prices}
        onPricesChange={(updatedPrices) => onPricesChange(id, updatedPrices)}
        value={value}
        onChange={onChange}
        options={options}
      />
    </Box>
  );
};


const TimeSlotApp = ({ priceCategories, onPriceCategoryChange, value, onChange, options, isTimeSlotAvailable }) => {
  const [timeSlots, setTimeSlots] = useState(
    priceCategories.length > 0
      ? priceCategories.map((slot, index) => ({ ...slot, id: index }))
      : [{ id: 0, timeSlot: "", prices: [] }] 
  );

  const selectedTimeSlots = timeSlots.map((slot) => slot.timeSlot).filter(Boolean);

  const handleAddTimeSlot = () => {
    if (isTimeSlotAvailable) return;

    const newSlot = { id: Date.now(), timeSlot: "", prices: [] };
    setTimeSlots((prevSlots) => {
      const updatedSlots = [...prevSlots, newSlot];
      onPriceCategoryChange(updatedSlots);
      return updatedSlots;
    });
  };


  const handleRemoveTimeSlot = (id) => {
    if (timeSlots.length === 1) return;
    setTimeSlots((prevSlots) => {
      const updatedSlots = prevSlots.filter((slot) => slot.id !== id);
      onPriceCategoryChange(updatedSlots);
      return updatedSlots;
    });
  };

  const handleTimeSlotChange = (id, field, value) => {
    console.log(`Changing timeSlot for ID ${id} to ${value}`);
    setTimeSlots((prevSlots) => {
      const updatedSlots = prevSlots.map((slot) =>
        slot.id === id ? { ...slot, [field]: value } : slot
      );
      console.log("Updated TimeSlots:", updatedSlots);
      onPriceCategoryChange(updatedSlots);
      return updatedSlots;
    });
  };



  const handlePricesChange = (id, updatedPrices) => {
    const cleanedPrices = updatedPrices.map((price) => ({
      price: price.price,
      salePrice: price.salePrice,
      age: price.age,
    }));

    setTimeSlots((prevTimeSlots) =>
      prevTimeSlots.map((slot) =>
        slot.id === id ? { ...slot, prices: cleanedPrices } : slot
      )
    );

    onPriceCategoryChange(
      timeSlots.map((slot) =>
        slot.id === id ? { ...slot, prices: cleanedPrices } : slot
      )
    );
  };

  return (
    <Box>
      {timeSlots.map((slot, index) => (
        <TimeSlot
          key={slot.id}
          id={slot.id}
          timeSlot={slot.timeSlot}
          prices={slot.prices}
          onTimeSlotChange={handleTimeSlotChange}
          onPricesChange={handlePricesChange}
          onAddTimeSlot={handleAddTimeSlot}
          onRemoveTimeSlot={timeSlots.length > 1 ? handleRemoveTimeSlot : null}
          showRemove={timeSlots.length > 1}
          selectedTimeSlots={selectedTimeSlots}
          value={value}
          onChange={onChange}
          options={options}
          isTimeSlotAvailable={isTimeSlotAvailable ? true : false}
        />
      ))}
    </Box>
  );
};

export default TimeSlotApp;

